import React, {useContext, useEffect, useState} from 'react'
import {InputErrorType, RoleContextValue, SubmitAPIStatusType} from '../../types/OtherTypes'
import {APIStatusData, SubmitAPIStatusData} from '../../data/OtherDefaultData'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import {changeTextCamal, checkRole} from '../../../_metronic/helpers'
import FeatureGate from '../../components/FeatureGate'
import {FEATURE_KEYS} from '../../features/featureRegistry'
import ActionColumn from '../../components/ActionColumn'
import {
  cancelSubmit,
  deleteRecord,
  getRecords,
  handleInputChange,
  handleSubmit,
} from '../../CommonFunction'
import {
  getEmploymentTypeByID,
  getEmploymentTypeTableHeaderData,
  validateForm,
} from './EmploymentTypesHelperFunction'
import CustomTable from '../../components/CustomTable'
import {Button} from '@mantine/core'
import {Modal} from 'react-bootstrap'
import API from '../../../api/APIUrl'
import CustomTextInput from '../../components/CustomInput/CustomTextInput'
import CustomNumberInput from '../../components/CustomInput/CustomNumberInput'
import {addEmploymentTypes, updateEmploymentTypesById} from '../../../api/EmploymentType'
import SubmitCancleButton from '../../components/SubmitCancelButton'
import {EmploymentTypeInput, EmploymentTypeOutput} from '../../types/AdminModuleTypes'
import {EmploymentTypeInitialInput} from '../../data/AdminModuleDefaultData'
import roleContext from '../../context/roleContext'

const EmploymentTypes = () => {
  let roleState: RoleContextValue = useContext(roleContext)
  const [editId, setEditId] = useState<string | null>(null)
  const [submitAPIStatus, setSubmitAPIStatus] = useState<SubmitAPIStatusType>(SubmitAPIStatusData)
  const [showForm, setShowForm] = useState<boolean>(false)
  const [inputError, setInputError] = useState<InputErrorType>({})
  const [expandedDescriptions, setExpandedDescriptions] = useState<Set<string>>(new Set())
  const {employmentTypeTableHeaderData} = getEmploymentTypeTableHeaderData(
    !checkRole(['employment_types'], roleState.features)
  )
  const [employmentType, setEmploymentType] = useState<EmploymentTypeOutput>({
    ...APIStatusData,
    data: [],
  })
  const [formField, setFormField] = useState<EmploymentTypeInput>(EmploymentTypeInitialInput)

  const toggleDescription = (id: string) => {
    setExpandedDescriptions((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(id)) {
        newSet.delete(id)
      } else {
        newSet.add(id)
      }
      return newSet
    })
  }

  const getTableBody = () => {
    return employmentType?.data.map((obj) => {
      const isExpanded = expandedDescriptions.has(obj?.id)
      const description = obj?.description || '-'
      const shouldTruncate = description.length > 25 && !isExpanded
      const displayDescription = shouldTruncate ? description.substring(0, 25) + '...' : description

      return (
        <tr key={obj?.id} className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}>
          <td>{changeTextCamal(obj?.name ?? '-')}</td>
          <td>{obj?.duration}</td>
          <td>
            {displayDescription}
            {description.length > 25 && (
              <button
                className='btn btn-link p-0 ms-1 text-primary'
                style={{fontSize: '12px'}}
                onClick={() => toggleDescription(obj?.id)}
              >
                {isExpanded ? 'View Less' : 'View More'}
              </button>
            )}
          </td>
          <td hidden={!checkRole(['employment_types'], roleState.features)}>
            <ActionColumn
              edit={{
                onClick: () => {
                  getEmploymentTypeByID(
                    obj.id,
                    formField,
                    setFormField,
                    setEditId,
                    setShowForm,
                    setInputError
                  )
                },
              }}
              remove={{
                onClick: () =>
                  deleteRecord(
                    `${API.EMPLOYMENTTYPE}/${obj.id}`,
                    setEmploymentType,
                    setFormField,
                    setEditId,
                    setInputError,
                    EmploymentTypeInitialInput,
                    setShowForm,
                    `${API.EMPLOYMENTTYPE}`
                  ),
              }}
            />
          </td>
        </tr>
      )
    })
  }
  useEffect(() => {
    let mounted = true
    if (mounted) {
      getRecords(`${API.EMPLOYMENTTYPE}`, setEmploymentType)
    }
    return () => {
      mounted = false
    }
  }, [])
  return (
    <div className='row justify-content-center'>
      <div className='col-md-7 col-12'>
        <CustomTable
          data={employmentType}
          setData={setEmploymentType}
          url={`${API.EMPLOYMENTTYPE}`}
          tableBody={getTableBody}
          tableHeadData={employmentTypeTableHeaderData}
          tableLabel='Employee Types'
          isSortingRequired={false}
          newRecordButton={
            <FeatureGate feature={FEATURE_KEYS.users_employment_types}>
              <Button
                type='button'
                className='btn btn-primary btn-sm me-3'
                onClick={() => setShowForm(true)}
                hidden={showForm}
              >
                Add Employement Types
              </Button>
            </FeatureGate>
          }
        />
        <Modal show={showForm} animation={false} backdrop='static' centered size='lg'>
          <div className='modal-header'>
            <h2 className='fw-bolder'>{editId !== null ? 'Update' : 'Add'} Employee Types</h2>
            <div
              className='btn btn-icon btn-sm btn-active-icon-danger'
              data-kt-users-modal-action='close'
              style={{cursor: 'pointer'}}
              onClick={() => {
                cancelSubmit(
                  setFormField,
                  setEditId,
                  setInputError,
                  EmploymentTypeInitialInput,
                  setShowForm
                )
              }}
            >
              <i className='fa-solid fa-xmark fs-1' />
            </div>
          </div>
          <div className='modal-body p-6'>
            <div className='row g-4'>
              <div className='col-md-6'>
                <CustomTextInput
                  name='name'
                  value={formField.name}
                  onChange={(event) =>
                    handleInputChange(event, setFormField, inputError, setInputError)
                  }
                  label='Employment Type'
                  id='name'
                  error={inputError.name}
                />
              </div>
              <div className='col-md-6'>
                <CustomNumberInput
                  label='Duration (in months)'
                  name='duration'
                  value={formField.duration}
                  onChange={(event) => {
                    handleInputChange(event, setFormField, inputError, setInputError)
                  }}
                  maxLength={4}
                  error={inputError.duration}
                />
              </div>
              <div className='col-12'>
                <label className='form-label required'>Description</label>
                <textarea
                  className={`form-control ${inputError.description ? 'is-invalid' : ''}`}
                  name='description'
                  value={formField.description}
                  onChange={(event) =>
                    handleInputChange(event, setFormField, inputError, setInputError)
                  }
                  rows={4}
                  maxLength={100}
                  placeholder='Enter employment type description...'
                />
                <div className='d-flex justify-content-between mt-1'>
                  <small className='text-muted'>Description must be 100 characters or fewer.</small>
                  <small className='text-muted'>
                    {formField.description.length}/100
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <SubmitCancleButton
              cancle={{
                onClick: () => {
                  cancelSubmit(
                    setFormField,
                    setEditId,
                    setInputError,
                    EmploymentTypeInitialInput,
                    setShowForm
                  )
                },
              }}
              submit={{
                editid: editId,
                loading: submitAPIStatus.loading,
                onClick: () =>
                  handleSubmit(
                    `${API.EMPLOYMENTTYPE}`,
                    formField,
                    EmploymentTypeInitialInput,
                    setEmploymentType,
                    setEditId,
                    setFormField,
                    editId,
                    setInputError,
                    validateForm,
                    setSubmitAPIStatus,
                    addEmploymentTypes,
                    updateEmploymentTypesById,
                    setShowForm
                  ),
              }}
            />
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default EmploymentTypes
